import { Route, Routes, Navigate } from 'react-router-dom';
import MainLayout from '../layouts/MainLayout';
import OverviewPage from '../pages/admin/AppCatalogue/Overview';
import AppsPage from '../pages/admin/AppCatalogue/Apps';
import NewAppPage from '../pages/admin/AppCatalogue/NewApp';
import EditAppPage from '../pages/admin/AppCatalogue/EditApp';
import RecommendationsPage from '../pages/admin/AppCatalogue/Recommendations';
import EntitlementPreviewPage from '../pages/admin/AppCatalogue/EntitlementPreviewPage';
import FeaturesPermissionsPage from '../pages/admin/AppCatalogue/FeaturesPermissions';
import DistributionPage from '../pages/admin/AppCatalogue/Distribution';
import DistributionDetailPage from '../pages/admin/AppCatalogue/DistributionDetail';
import CodesPage from '../pages/admin/AppCatalogue/Codes';
import CodesDetailPage from '../pages/admin/AppCatalogue/CodesDetail';

/**
 * App Catalogue Routes
 *
 * Full domain app mounted under the Admin-gated /admin/app-catalogue/* tree
 * (see AdminRoutes.tsx, which itself sits under the Admin ProtectedRoute in
 * App.tsx). Each page is wrapped in the shared MainLayout with
 * domainKey="app-catalogue" so it gets the App Catalogue left sidebar.
 *
 * Pages:
 * - /admin/app-catalogue                  - Overview (client-side stats)
 * - /admin/app-catalogue/apps             - App manifest list (search/toggle/delete)
 * - /admin/app-catalogue/apps/new         - Create a manifest
 * - /admin/app-catalogue/apps/edit/:appId - Edit a manifest
 * - /admin/app-catalogue/recommendations  - Ranked recommendations + recompute
 * - /admin/app-catalogue/entitlements     - Entitlement preview smoke-test
 * - /admin/app-catalogue/features         - Features & Permissions editor
 * - /admin/app-catalogue/distribution     - How each app reaches a phone (private distribution)
 * - /admin/app-catalogue/codes            - The redemption-code pool: upload, assign, track use
 */
export default function AppCatalogueRoutes() {
  return (
    <Routes>
      <Route
        index
        element={
          <MainLayout domainKey="app-catalogue">
            <OverviewPage />
          </MainLayout>
        }
      />

      <Route
        path="apps"
        element={
          <MainLayout domainKey="app-catalogue">
            <AppsPage />
          </MainLayout>
        }
      />

      <Route
        path="apps/new"
        element={
          <MainLayout domainKey="app-catalogue">
            <NewAppPage />
          </MainLayout>
        }
      />

      <Route
        path="apps/edit/:appId"
        element={
          <MainLayout domainKey="app-catalogue">
            <EditAppPage />
          </MainLayout>
        }
      />

      <Route
        path="recommendations"
        element={
          <MainLayout domainKey="app-catalogue">
            <RecommendationsPage />
          </MainLayout>
        }
      />

      <Route
        path="entitlements"
        element={
          <MainLayout domainKey="app-catalogue">
            <EntitlementPreviewPage />
          </MainLayout>
        }
      />

      <Route
        path="features"
        element={
          <MainLayout domainKey="app-catalogue">
            <FeaturesPermissionsPage />
          </MainLayout>
        }
      />

      <Route
        path="distribution"
        element={
          <MainLayout domainKey="app-catalogue">
            <DistributionPage />
          </MainLayout>
        }
      />

      <Route
        path="distribution/:appId"
        element={
          <MainLayout domainKey="app-catalogue">
            <DistributionDetailPage />
          </MainLayout>
        }
      />

      <Route
        path="codes"
        element={
          <MainLayout domainKey="app-catalogue">
            <CodesPage />
          </MainLayout>
        }
      />

      <Route
        path="codes/:appId"
        element={
          <MainLayout domainKey="app-catalogue">
            <CodesDetailPage />
          </MainLayout>
        }
      />

      {/* Unknown sub-path -> Overview */}
      <Route path="*" element={<Navigate to="/admin/app-catalogue" replace />} />
    </Routes>
  );
}
